import React from 'react'
import {BaseButton, Text, Flex} from '../../vanilla'
import {Link} from '../../components/link'

export const MealDealContinueBox: React.FC = () => {
  return (
    <Flex
      flexDirection="column"
      gap="16px"
      justifyContent="center"
      alignItems="center"
      width="full"
      backgroundColor="white"
      paddingY="20px"
      paddingX="16px"
      borderRadius="base"
    >
      <BaseButton
        as={Link}
        to="/offers"
        size="lg"
        width={['full', 'auto']}
        data-test-selector="continue-shopping"
      >
        <Text variant="text4">Continue Shopping</Text>
      </BaseButton>
      <Text
        variant="text3"
        color={{default: 'accent6'}}
        textDecoration="underline"
        to="/meal-deals"
        as={Link}
        data-test-selector="view-more-deals"
      >
        View More Deals
      </Text>
    </Flex>
  )
}
